// Turn a stored relative path (e.g. "/api/files/<id>") into an absolute URL
// against the current backend, keeping stories portable across environments.
export const abs = (url) => {
    if (!url) return url;
    if (/^https?:\/\//i.test(url)) return url;
    const base = process.env.REACT_APP_BACKEND_URL || '';
    return `${base}${url.startsWith('/') ? '' : '/'}${url}`;
};

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const formatDate = (iso) => {
    if (!iso) return '';
    try {
        return new Date(iso).toLocaleDateString('en-US', {
            day: 'numeric',
            month: 'long',
            year: 'numeric',
        });
    } catch {
        return '';
    }
};
